"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var ProductBasedOfferIds = _interopRequireWildcard(require("self-service-api/constants/ProductBasedOfferIds"));

var _ProductBasedOfferIds;

var _default = (_ProductBasedOfferIds = {}, (0, _defineProperty2.default)(_ProductBasedOfferIds, ProductBasedOfferIds.FREE_CRM_SALES_STARTER_KIT, {
  trackingName: 'Starter Kit - Free',
  active: false
}), (0, _defineProperty2.default)(_ProductBasedOfferIds, ProductBasedOfferIds.FREE_SERVICE_PROFESSIONAL_ONBOARDING, {
  trackingName: 'Service Professional Onboarding - Free',
  active: false
}), (0, _defineProperty2.default)(_ProductBasedOfferIds, ProductBasedOfferIds.SALES_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT, {
  trackingName: 'Sales Professional Onboarding - 50%',
  active: true
}), (0, _defineProperty2.default)(_ProductBasedOfferIds, ProductBasedOfferIds.SERVICE_PROFESSIONAL_ONBOARDING_50_PERCENT_DISCOUNT, {
  trackingName: 'Service Professional Onboarding - 50%',
  active: true
}), _ProductBasedOfferIds);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/ImmutableProductBasedOfferIdMap.js
// module id = 358
// module chunks = 5 6 7